export const sortObject = (obj: any) => {
    return Object.keys(obj)
        .sort()
        .reduce(function (result: any, key: any) {
            result[key] = obj[key];
            return result;
        }, {});
};
